import React from "react";
import Dropdown from "../../../components/Dropdown";
export default function TableDashboard() {
  return (
    <div className="col-mt-w100">
      <div className="row-jcct-gab2">
        <div className="col">
          <p className="txt-main-content4">Year</p>
          <Dropdown
            items={["2564", "2563", "2562", "2561"]}
            itemCallback={(item) => {
              console.log(item);
            }}
            hasFilter={false}
          />
        </div>
        <div className="col">
          <p className="txt-main-content4">month</p>
          <Dropdown
            items={[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ]}
            itemCallback={(item) => {
              console.log(item);
            }}
            hasFilter={false}
          />
        </div>
        <div className="col">
          <p className="txt-main-content4">Term</p>
          <Dropdown
            items={["1", "2"]}
            itemCallback={(item) => {
              console.log(item);
            }}
            hasFilter={false}
          />
        </div>
      </div>
      <div className="row-gab2-mt2">
        <div className="box-graph-dashbaord">
          <div className="row-jcct">
            <p className="txt-main-content4">Attendance</p>
          </div>
        </div>
        <div className="box-graph-dashbaord">
          <div className="row-jcct">
            <p className="txt-main-content4">Temperature</p>
          </div>
        </div>
      </div>
      <div className="row-gab2-my2">
        <div className="box-graph-dashbaord">
          <div className="row-jcct">
            <p className="txt-main-content4">History illness</p>
          </div>
        </div>
        <div className="box-graph-dashbaord">
          <div className="row-jcct">
            <p className="txt-main-content4">Growth</p>
          </div>
        </div>
      </div>
    </div>
  );
}
